// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interviews-container {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
    font-family: 'Inter', sans-serif;
  }
  
  .interviews-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .interviews-header h2 {
    margin: 0;
    font-size: 2rem;
    color: #333333;
  }
  
  .start-new-button {
    padding: 12px 24px;
    background-color: #007BFF;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s ease, transform 0.2s ease;
  }
  
  .start-new-button:hover {
    background-color: #0056b3;
    transform: translateY(-2px);
  }
  
  .start-new-button:active {
    background-color: #004494;
    transform: translateY(0);
  }
  
  .interviews-table {
    width: 100%;
    border-collapse: collapse;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .interviews-table th,
  .interviews-table td {
    padding: 16px;
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
  }
  
  .interviews-table th {
    background-color: #f8f9fa;
    color: #343a40;
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 1;
  }
  
  .interviews-table tr:nth-child(even) {
    background-color: #f2f2f2;
  }
  
  .interviews-table tr:hover {
    background-color: #e9ecef;
  }
  
  .error-message {
    color: #D8000C;
    background-color: #FFBABA;
    padding: 15px;
    border-radius: 5px;
    margin-bottom: 20px;
  }
  
  .table-responsive {
    overflow-x: auto;
  }
  
  @media (max-width: 768px) {
    .interviews-header h2 {
      font-size: 1.5rem;
    }
  
    .start-new-button {
      padding: 10px 20px;
      font-size: 0.9rem;
    }
  
    .interviews-table th,
    .interviews-table td {
      padding: 12px;
      font-size: 0.9rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/Interviews.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2DAA2D;EAC7D;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;;IAEE,aAAa;IACb,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,UAAU;EACZ;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,iBAAiB;IACnB;;IAEA;;MAEE,aAAa;MACb,iBAAiB;IACnB;EACF","sourcesContent":[".interviews-container {\n    padding: 20px;\n    max-width: 1200px;\n    margin: 0 auto;\n    font-family: 'Inter', sans-serif;\n  }\n  \n  .interviews-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n  }\n  \n  .interviews-header h2 {\n    margin: 0;\n    font-size: 2rem;\n    color: #333333;\n  }\n  \n  .start-new-button {\n    padding: 12px 24px;\n    background-color: #007BFF;\n    color: #ffffff;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 1rem;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n  }\n  \n  .start-new-button:hover {\n    background-color: #0056b3;\n    transform: translateY(-2px);\n  }\n  \n  .start-new-button:active {\n    background-color: #004494;\n    transform: translateY(0);\n  }\n  \n  .interviews-table {\n    width: 100%;\n    border-collapse: collapse;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  .interviews-table th,\n  .interviews-table td {\n    padding: 16px;\n    text-align: left;\n    border-bottom: 1px solid #e0e0e0;\n  }\n  \n  .interviews-table th {\n    background-color: #f8f9fa;\n    color: #343a40;\n    font-weight: 600;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n  }\n  \n  .interviews-table tr:nth-child(even) {\n    background-color: #f2f2f2;\n  }\n  \n  .interviews-table tr:hover {\n    background-color: #e9ecef;\n  }\n  \n  .error-message {\n    color: #D8000C;\n    background-color: #FFBABA;\n    padding: 15px;\n    border-radius: 5px;\n    margin-bottom: 20px;\n  }\n  \n  .table-responsive {\n    overflow-x: auto;\n  }\n  \n  @media (max-width: 768px) {\n    .interviews-header h2 {\n      font-size: 1.5rem;\n    }\n  \n    .start-new-button {\n      padding: 10px 20px;\n      font-size: 0.9rem;\n    }\n  \n    .interviews-table th,\n    .interviews-table td {\n      padding: 12px;\n      font-size: 0.9rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
